import merge from 'lodash.merge';
import { commonMessages } from '../messages/common';
import { comparisonSelfServeMessages } from '../messages/comparison-self-serve';
import { comparisonTableHeroV2Messages } from '../messages/comparison-table-hero-v2';
export const ComparisonSelfServeTranslations = merge(undefined, commonMessages, comparisonSelfServeMessages, comparisonTableHeroV2Messages);
